<template>
  <a-dropdown>
    <a-button type="link" style="padding: 4px 0;">{{ para.timeName }}：</a-button>
    <template #overlay>
      <a-menu v-if="timeTypes.length > 0">
        <a-menu-item v-for="item in timeTypes" :key="item.value" @click="() => onClick(item)">
          {{ item.label }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <a-select v-model:value="para.type" :options="rangeTime" @select="onSelect" style="width: 100px">
  </a-select>
  <a-range-picker v-model:value="para.range" v-if="para.type === 60" :show-time="showTime" :minute-step="5"
    :second-step="60" @change="onChange" class="custom-pick" :class="{ 'no-time': !showTime }" />
</template>
<script setup lang="ts">
import dayjs, { Dayjs } from 'dayjs'
import { onMounted, ref, reactive } from 'vue'

const props = withDefaults(defineProps<{
  time: HuaskyTime
  typeOptions?: string[]
  rangeOptions?: string[]
  showTime?: boolean
}>(), {
  showTime: false
})

const emit = defineEmits(['update:time'])

const types = [
  { label: '下单时间', value: 'CreatedTime' },
  { label: '评价时间', value: 'CreatedTime', hidden: true },
  { label: '提交时间', value: 'SubmitTime' },
  { label: '支付时间', value: 'PayTime' },
]
const ranges = [
  { label: '全部', value: 0 },
  { label: '今天', value: 1 },
  { label: '昨天', value: 7 },
  { label: '午市', value: 5 },
  { label: '晚市', value: 6 },
  { label: '两天内', value: 2 },
  { label: '本月', value: 3 },
  { label: '近一个月', value: 4 },
  { label: '自定义', value: 60 },
]

const timeTypes = ref([])
const rangeTime = ref([])

type RangeValue = [Dayjs?, Dayjs?]
const para = reactive({
  timeName: props.time.timeName,
  timeField: props.time.timeField,
  type: props.time.type,
  range: [$util.getTodayTime(), $util.getTodayTime('23:00:00')] as RangeValue,
})

/**
 * 选择时间类型
 * @param a
 */
const onClick = (a: CommonOption) => {
  para.timeName = a.label
  para.timeField = a.value
  submit()
}

/**
 * 选择时间区间
 * @param a
 */
const onSelect = (a: any) => {
  setTime()
  submit()
}

/**
 * 改变自定义时间
 * @param _
 * @param arr
 */
const onChange = (_: any, arr: string[]) => {
  submit()
}

/**
 * 根据选择的时间范围，计算开始时间和结束时间
 */
const setTime = () => {
  if (para.type !== 60) return
  para.range[0] = props.time.startTime ? dayjs(props.time.startTime) : $util.getTodayTime()
  para.range[1] = props.time.endTime ? dayjs(props.time.endTime) : $util.getTodayTime('23:00:00')
}

onMounted(() => {
  if (props.typeOptions?.length > 0) {
    timeTypes.value = types.filter((a) => props.typeOptions.indexOf(a.label) > -1)
  } else {
    timeTypes.value = types.filter(a => !a.hidden)
  }
  if (props.rangeOptions?.length > 0) {
    rangeTime.value = ranges.filter((a) => props.rangeOptions.indexOf(a.label) > -1)
  } else {
    rangeTime.value = ranges
  }
  setTime()
})

const submit = () => {
  const obj = {
    timeField: para.timeField,
    timeName: para.timeName,
    type: para.type,
    startTime: para.range[0]?.format('YYYY-MM-DD HH:mm:ss'),
    endTime: para.range[1]?.format('YYYY-MM-DD HH:mm:ss'),
  } as HuaskyTime
  emit('update:time', obj)
}
</script>
<style scoped lang="scss">
.custom-pick {
  margin-left: 10px;
  width: 350px;

  &.no-time {
    width: 240px
  }

}
</style>